/* MDB: keep Google badge bottom-aligned with Shopify Inbox Live chat */
(function () {
  if (window.__mdbGBadgeAlign) return;
  window.__mdbGBadgeAlign = true;

  function chatNode() {
    var host = document.querySelector('shopify-chat');
    if (host) {
      try {
        if (host.shadowRoot) {
          var inner =
            host.shadowRoot.querySelector('[part="button"], button, [role="button"], a') ||
            host.shadowRoot.querySelector('[class*="activator"], [class*="launcher"], [class*="button"]');
          if (inner) return inner;
        }
      } catch (e) {}
      return host;
    }
    return document.querySelector('#shopify-chat, [id*="ShopifyChat"]');
  }

  function ensureSoftStyle() {
    if (document.getElementById('mdb-g-badge-align')) return;
    var style = document.createElement('style');
    style.id = 'mdb-g-badge-align';
    style.textContent =
      '.mdb-g-badge{background:rgba(255,255,255,.92)!important;-webkit-backdrop-filter:saturate(1.2) blur(10px);backdrop-filter:saturate(1.2) blur(10px);border:1px solid rgba(0,0,0,.08);box-shadow:0 1px 6px rgba(0,0,0,.1)!important;' +
      'bottom:var(--shopify-chat-activator-offset,80px)!important;}';
    (document.head || document.documentElement).appendChild(style);
  }

  function align() {
    ensureSoftStyle();
    var badge = document.querySelector('[data-mdb-g-badge], .mdb-g-badge');
    if (!badge) return;
    var chat = chatNode();
    if (!chat) return;
    var rect = chat.getBoundingClientRect();
    if (rect.width < 4 || rect.height < 4 || rect.bottom < 0) return;
    var bottom = Math.max(0, Math.round(window.innerHeight - rect.bottom));
    badge.style.setProperty('bottom', bottom + 'px', 'important');
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      align();
    });
  }

  function boot() {
    align();
    var tries = 0;
    var tick = setInterval(function () {
      align();
      tries += 1;
      if (tries > 40) clearInterval(tick);
    }, 250);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(schedule).observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style'],
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

